import { LoginSearchParamsSchema } from '@/src/domains/auth/schemas'
import { resolveLoginRedirectUrl } from '@/src/domains/auth/utils/resolveLoginRedirectUrl'
import { useParsedSearchParams } from '@/src/hooks/useParsedSearchParams'

export const useLoginParams = () => {
  const searchParams = useParsedSearchParams(LoginSearchParamsSchema)
  const params = searchParams?.params

  return {
    email: params?.email,
    redirectUrl: resolveLoginRedirectUrl(params, searchParams?.redirectUrl),
  }
}
